import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createReturnReasonConfigBottom, createReturnReasonConfigTop } from "../mockCore";

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Asket-Jeans-Stone.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Stone Wash",
                        },
                        {
                            type: "Build",
                            value: "Slim",
                        },
                        {
                            type: "Size",
                            value: "28/30",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Asket-Jeans-Stone.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Stone Wash",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "28/30",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Asket-Jeans-Stone.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Stone Wash",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "29/30",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Asket-Jeans-Stone.png",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Stone Wash",
                        },
                        {
                            type: "Build",
                            value: "Slim",
                        },
                        {
                            type: "Size",
                            value: "29/32",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Asket-Jeans-Stone.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Stone Wash",
                        },
                        {
                            type: "Build",
                            value: "Slim",
                        },
                        {
                            type: "Size",
                            value: "30/30",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Asket-Jeans-Bleach.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Stone Bleach",
                        },
                        {
                            type: "Build",
                            value: "Slim",
                        },
                        {
                            type: "Size",
                            value: "28/30",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Asket-Jeans-Bleach.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Stone Bleach",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "28/30",
                        },
                    ],
                },
                {
                    id: "8",
                    imageUrl: "/mocks/Asket-Jeans-Bleach.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Stone Bleach",
                        },
                        {
                            type: "Build",
                            value: "Slim",
                        },
                        {
                            type: "Size",
                            value: "29/30",
                        },
                    ],
                },
                {
                    id: "9",
                    imageUrl: "/mocks/Asket-Jeans-Bleach.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Stone Bleach",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "29/32",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Asket-T-shirt-Black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Build",
                            value: "Short",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Asket-T-shirt-Black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Asket-T-shirt-Black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Build",
                            value: "Long",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Asket-T-shirt-Black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Asket-T-shirt-White.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Build",
                            value: "Short",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Asket-T-shirt-White.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Asket-T-shirt-White.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "8",
                    imageUrl: "/mocks/Asket-T-shirt-Grey.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Grey Melange",
                        },
                        {
                            type: "Build",
                            value: "Long",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "9",
                    imageUrl: "/mocks/Asket-T-shirt-Grey.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Grey Melange",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "10",
                    imageUrl: "/mocks/Asket-T-shirt-Grey.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Grey Melange",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "11",
                    imageUrl: "/mocks/Asket-T-shirt-Dark-Navy.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Dark Navy",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Asket-Coat-Biege.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Biege",
                        },
                        {
                            type: "Build",
                            value: "Short",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Asket-Coat-Biege.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Biege",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Asket-Coat-Biege.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Biege",
                        },
                        {
                            type: "Build",
                            value: "Long",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Asket-Coat-Biege.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Biege",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Asket-Coat-Dark-Navy.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Dark Navy",
                        },
                        {
                            type: "Build",
                            value: "Short",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Asket-Coat-Dark-Navy.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Dark Navy",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Asket-Coat-Dark-Navy.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Dark Navy",
                        },
                        {
                            type: "Build",
                            value: "Regular",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
            ],
        };
    }
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        pickupDateSelectionAllowed: true,
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: [
            {
                productVariantId: 10,
                sessionItemId: 1,
                productName: "The Washed Denim Jeans",
                imageSrc: "/mocks/Asket-Jeans-Stone.png",
                imageAlt: "/mocks/Asket-Jeans-Stone.png",
                quantity: 1,
                purchasePrice: 1350,
                properties: [
                    {
                        type: "Build",
                        value: "Slim",
                    },
                    {
                        type: "Size",
                        value: "29/30",
                    },
                    {
                        type: "Color",
                        value: "Stone Wash",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigBottom(),
            },
            {
                productVariantId: 20,
                sessionItemId: 2,
                productName: "The T-Shirt",
                imageSrc: "/mocks/Asket-T-shirt-Black.png",
                imageAlt: "/mocks/Asket-T-shirt-Black.png",
                quantity: 1,
                purchasePrice: 400,
                properties: [
                    {
                        type: "Build",
                        value: "Regular",
                    },
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "Black",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
            {
                productVariantId: 30,
                sessionItemId: 3,
                productName: "The Car Coat",
                imageSrc: "/mocks/Asket-Coat-Biege.png",
                imageAlt: "/mocks/Asket-Coat-Biege.png",
                quantity: 1,
                purchasePrice: 3000,
                properties: [
                    {
                        type: "Build",
                        value: "Regular",
                    },
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "Biege",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
        ],
    };
}
